module.exports = __webpack_public_path__ + "static/img/4477_phase_function_Paper_PointsHejduk_Prediction.050eca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4477_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Bs8x
// module chunks = 0